import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import Layout from './components/layout';
import {
  HomePage,
  GamesPage,
  GameDetailPage,
  AboutPage,
  PlayNowPage,
  PrivacyPolicyPage,
  TermsPage,
  CookiePolicyPage,
  SalaTakatifuPrivacyPage,
  NotFoundPage,
  PlatformsPage,
  ContactPage,
  TeamPage,
  LegalHubPage,
  AppPrivacyPage,
  AppTermsPage,
  DocBladePrivacyPage,
} from './pages';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="games" element={<GamesPage />} />
            <Route path="games/:slug" element={<GameDetailPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="play" element={<PlayNowPage />} />
            <Route path="platforms" element={<PlatformsPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="legal" element={<LegalHubPage />} />
            <Route path="privacy" element={<PrivacyPolicyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="cookies" element={<CookiePolicyPage />} />
            <Route path="sala-takatifu/privacy" element={<SalaTakatifuPrivacyPage />} />
            <Route path="apps/:appSlug/privacy" element={<AppPrivacyPage />} />
            <Route path="apps/:appSlug/terms" element={<AppTermsPage />} />
            <Route path="docblade/privacy" element={<DocBladePrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
